// components/chat/ChatHeader.jsx
import React from 'react';

export default function ChatHeader({ isRecording, isPlayingAudio }) {
  return (
    <div></div>
    // <div className="flex items-center justify-between px-3 py-2 border-b border-gray-200 bg-white/70 backdrop-blur-sm">
    //   {/* <h2 className="font-semibold">How can I help you?</h2> */}
    // </div>
  );
}
